/* eslint-disable @typescript-eslint/no-explicit-any,
jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions,
@typescript-eslint/no-unused-vars, react/no-unused-prop-types */
import React from 'react';
import {
  ListItem, ListItemButton, Tooltip, Typography,
} from '@mui/material';
import { twMerge } from 'tailwind-merge';
import { motion } from 'framer-motion';
import { useLocation, useNavigate } from 'react-router-dom';
import { ExpandDownIcon } from 'src/icons';
import { ModuleType } from 'src/access';

export interface IMenuItem {
  Icon: React.ComponentType<any>;
  name: string;
  href?: string;
  module?: ModuleType;
  modules?: ModuleType[];
  childrenList?: IMenuItem[];
  url?: string;
}
interface MenuItemProps extends IMenuItem {
  expanded: boolean;
  selected?: boolean;
  onClick: (href: string, url: string) => void;
  isChild?: boolean;
}

const MenuItem = function MenuItem(props: MenuItemProps) {
  const {
    expanded,
    Icon,
    name,
    selected,
    onClick,
    href = '',
    url = '',
    childrenList,
    isChild = false,
  } = props;
  const location = useLocation();
  const navigate = useNavigate();
  return (
    <ListItem
      disablePadding
      sx={{ display: 'flex' }}
    >
      <div className="flex flex-col w-full">
        <div
          className="flex flex-1 w-full h-[60px] relative"
          style={{ background: selected ? 'rgba(249, 113, 113, 0.08)' : '' }}
          onClick={() => onClick(href, url)}
        >
          {selected ? (
            <motion.div
              className={twMerge('left-0 top-0 bottom-0 absolute bg-primary', expanded ? 'w-1' : 'w-1')}
              layoutId={`underline-${isChild ? 'child' : ''}`}
            />
          ) : <div />}
          <Tooltip title={expanded ? '' : name} placement="right">
            <ListItemButton
              sx={{
                minHeight: 44,
                justifyContent: expanded ? 'initial' : 'center',
                px: 4.5,
              }}
              className={twMerge(
                `${selected ? 'border border-l-2 border-primary' : ''} relative`,
                isChild && expanded && 'ml-4',
              )}
            >
              {childrenList && childrenList.length > 0 && (
                <ExpandDownIcon className={twMerge('absolute left-2', selected && 'rotate-180', !expanded && 'hidden')} />
              )}
              <div
                className={twMerge(
                  'flex justify-center items-center',
                  expanded ? 'flex-row' : 'flex-col',
                )}
              >
                <Icon className={twMerge(selected ? 'fill-primary  stroke-primary' : 'fill-secondary stroke-secondary', expanded && 'mr-3')} />
                <Typography className={twMerge(!expanded ? 'text-[8px]' : 'text-[16px]')}>{name}</Typography>
              </div>
            </ListItemButton>
          </Tooltip>
        </div>
        {childrenList && selected && childrenList.length > 0 && (
          <div className="flex flex-col border">
            {childrenList.map((item) => {
              const selectedChild = location.pathname.includes(item.href as string);
              const onClickHandler = () => {
                navigate(item.href || '/', { replace: true });
              };
              return (
                <MenuItem
                  selected={selectedChild}
                  key={item.name}
                  onClick={onClickHandler}
                  expanded={expanded}
                  href={item.href}
                  url={item.url}
                  name={item.name}
                  Icon={item.Icon}
                  isChild
                />
              );
            })}
          </div>
        )}
      </div>
    </ListItem>
  );
};

MenuItem.defaultProps = {
  href: '',
  selected: false,
  isChild: false,
  childrenList: [],
  module: undefined,
  modules: undefined,
  url: '',
};

MenuItem.propTypes = {

};

export default MenuItem;
